// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"9361d30f","401":"86ef35b7","435":"c060c190","455":"8a69db02","529":"c060c190","540":"63234c2a","912":"c060c190"}[chunkId] + ".chunk.css";
};